import { css, cx } from "@emotion/css";
import { ReactNode } from "react";

import { useTheme } from "../hooks/useTheme";
import { Theme } from "../utils/createTheme";

interface AnonymousPageBoxProps {
  children: ReactNode;
  className?: string;
}

export function AnonymousPageBox({
  children,
  className,
}: AnonymousPageBoxProps) {
  const theme = useTheme();
  const classes = createStyles(theme);
  return <div className={cx(classes.root, className)}>{children}</div>;
}

function createStyles({ spacing }: Theme) {
  return {
    root: css({
      maxWidth: 330,
      margin: "0 auto",
      width: "100%",
      padding: spacing([0, 1, 4]),
    }),
  };
}
